import React from 'react';
import { CheckSquare } from 'lucide-react';

const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-indigo-500" />
        Дополнительные параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Досрочное погашение */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeEarlyRepayment"
              checked={formData.includeEarlyRepayment}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать досрочное погашение
            </span>
          </label>
        </div>

        {/* Комиссии */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeFees"
              checked={formData.includeFees}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать комиссии банка
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;